import { Box, styled } from '@mui/material';

export const TopBarContainer = styled(Box)(({ theme }) => ({
  marginTop: 24,
  marginBottom: 24,
}));

export const FirstRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobileView',
})<{ isMobileView: boolean }>(({ isMobileView }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: isMobileView ? 'center' : 'flex-start',
  paddingBottom: '24px',
}));

export const SecondRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobileView',
})<{ isMobileView: boolean }>(({ isMobileView }) => ({
  display: 'flex',
  paddingTop: 24,
}));

export const LeftBar = styled(Box, {
  shouldForwardProp: (props) => props !== '',
})(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const RightBar = styled(
  Box,
  {}
)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
}));

export const WelcomeBox = styled(
  Box,
  {}
)(() => ({
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
  justifyContent: 'center',
}));
